<section class="suppliers" role="main">
  <header class="suppliers__header">
    <h1 class="suppliers__title" tabindex="0">{{ 'VENDORS.TITLE' | translate }}</h1>
    <p class="suppliers__subtitle" tabindex="0">
      {{ 'VENDORS.SUBTITLE' | translate }}
    </p>
  </header>

  <div class="suppliers__grid">
    <article
      class="supplier-card"
      *ngFor="let supplier of suppliers; trackBy: trackById"
      [attr.aria-label]="supplier.name"
    >
      <div class="supplier-card__logo">
        <img
          [src]="supplier.logo"
          [alt]="supplier.name"
          loading="lazy"
        />
      </div>

      <div class="supplier-card__content">
        <h2 class="supplier-card__name" tabindex="0">{{ supplier.name }}</h2>
        <p class="supplier-card__desc" tabindex="0">{{ supplier.description }}</p>

        <div class="supplier-card__meta" role="group" [attr.aria-label]="'VENDORS.INFO_LABEL' | translate">
          <span tabindex="0">{{ supplier.country }}</span>
          <span aria-hidden="true">•</span>
          <span tabindex="0">{{ supplier.category }}</span>
        </div>
      </div>
    </article>
  </div>
</section>